export default "__VITE_ASSET__B5Et8xw3__"